import React, { useEffect, useRef, useState } from 'react';

const faqs = [
  {
    q: '¿Cómo agendo una cita?',
    a: 'Puedes agendar en línea desde nuestra web o escribirnos por WhatsApp/Instagram. Confirmaremos fecha y hora según disponibilidad.'
  },
  {
    q: '¿Qué métodos de pago aceptan?',
    a: 'Aceptamos efectivo, tarjetas de débito/crédito y transferencias. Pregunta por promociones vigentes.'
  },
  {
    q: '¿Trabajan con productos veganos o cruelty-free?',
    a: 'Sí. Priorizamos marcas con fórmulas responsables y de alta calidad, cuidando tu cabello y el medio ambiente.'
  },
  {
    q: '¿Ofrecen asesoría personalizada para cambios de look?',
    a: 'Por supuesto. Evaluamos tu estilo, rutina y objetivos para recomendar cortes, color y tratamientos acordes a tu personalidad.'
  }
];

const AccordionItem = ({ q, a }) => {
  const [open, setOpen] = useState(false);
  const contentRef = useRef(null);
  const [maxH, setMaxH] = useState(0);

  useEffect(() => {
    if (open && contentRef.current) {
      setMaxH(contentRef.current.scrollHeight);
    } else {
      setMaxH(0);
    }
  }, [open]);

  return (
    <div className="border-b">
      <button
        type="button"
        onClick={() => setOpen(!open)}
        aria-expanded={open}
        className="w-full flex items-center justify-between py-4 text-left"
      >
        <span className="font-medium">{q}</span>
        <span className={`text-xl leading-none select-none transition-transform duration-300 ${open ? 'rotate-45' : ''}`}>{open ? '-' : '+'}</span>
      </button>
      <div
        style={{ maxHeight: maxH }}
        aria-hidden={!open}
        className="overflow-hidden transition-[max-height] duration-300 ease-out"
      >
        <div ref={contentRef} className={`pb-4 transition-opacity duration-300 ${open ? 'opacity-100' : 'opacity-0'}`}>
          <p className="text-sm md:text-base leading-relaxed">{a}</p>
        </div>
      </div>
    </div>
  );
};

const FAQ = () => {
  return (
    <section id="faq" className="w-full bg-white py-16">
      <div className="max-w-6xl mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-start">
          {/* Columna Izquierda */}
          <div>
            <h2 className="font-serif font-bold text-2xl md:text-3xl mb-6">Preguntas Frecuentes</h2>
            <div className="divide-y-0">
              {faqs.map((item, idx) => (
                <AccordionItem key={idx} q={item.q} a={item.a} />
              ))}
            </div>
          </div>
          {/* Columna Derecha */}
          <div className="flex">
            <div className="w-full p-3 border border-gray-300">
              <img
                src="/images/faq-image.jpg"
                alt="Inspiración y estética del salón Frahda Studio"
                className="w-full h-auto md:h-[420px] object-cover rounded-lg shadow-md"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
